import React, { useState, useEffect } from "react";

import HorizontalListItem from "../components/HorizontalListItem";
import VerticalListItem from "../components/VerticalListItem";
import searchIcon from "../assets/res/search.svg";
import logo from "../assets/res/logo_infinite.svg";

const GamesPage = ({
  handleItemClick,
  handleSearchEvent,
  showOverlayHeader,
  numbers,
}) => {
  const [filteredGames, setFilteredGames] = useState([]);

  useEffect(() => {
    setFilteredGames(numbers); // Create a copy using slice()
  }, [numbers]);

  return (
    <div className="flex  flex-col  relative w-screen bg-gradient-to-r from-semi-blue to-light-blue">
      <div className="flex flex-row justify-between items-center p-4  rounded-b-xl shadow-md">
        {/*  <div className="h-[24px] w-[24px] bg-black"></div> */}
        <div className="flex flex-row items-center">
          <img src={logo} width="40" height="40" alt="Search" />
          <h1 className="ml-2 pressStart text-2xl tracking-wider bg-gradient-to-r from-white to-white bg-clip-text text-transparent">
            MOD{" "}
          </h1>
        </div>

        <div class="relative rounded-3xl">
          <div class="absolute -inset-1  bg-gradient-to-r from-yellow-500 via-orange-600 to-red-600 opacity-95 blur rounded-3xl"></div>
          <div class="relative flex rounded-3xl items-center justify-center  bg-slate-900 text-slate-300">
            <div
              className="flex flex-row justify-center items-center rounded-3xl bg-dark-blue px-[12px] py-[6px]"
              onClick={() => handleSearchEvent("Search")}
            >
              <div className="flex flex-wrap flex-col place-items-center">
                <img src={searchIcon} width="24" height="24" alt="Search" />
              </div>
              <div className="text-white ml-2 semiBold">Search</div>
            </div>
          </div>
        </div>
      </div>

      {showOverlayHeader == true && (
        <div class="fixed flex top-0 left-0 right-0 items-center  h-16 z-40 backdrop-blur-2xl animate-appear  rounded-b-xl shadow-md bg-light-blue/60">
          <div className="flex flex-row justify-between items-center p-4 w-screen  rounded-b-xl">
            {/*  <div className="h-[24px] w-[24px] bg-black"></div> */}
            <div className="flex flex-row items-center">
              <img src={logo} width="40" height="40" alt="Search" />
              <h1 className="ml-2 pressStart text-2xl tracking-wider bg-gradient-to-r from-white to-white bg-clip-text text-transparent">
                MOD
              </h1>
            </div>

            <div class="relative rounded-3xl">
              <div class="absolute -inset-1  bg-gradient-to-r from-yellow-500 via-orange-600 to-red-600 opacity-95 blur rounded-3xl"></div>
              <div class="relative flex rounded-3xl items-center justify-center  bg-slate-900 text-slate-300">
                <div
                  className="flex flex-row justify-center items-center rounded-3xl bg-dark-blue px-[12px] py-[6px]"
                  onClick={() => handleSearchEvent("Search")}
                >
                  <div className="flex flex-wrap flex-col place-items-center">
                    <img src={searchIcon} width="24" height="24" alt="Search" />
                  </div>
                  <div className="text-white ml-2 semiBold">Search</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <h2 className="text-white medium text-2xl  mx-4 tracking-wide mt-4">
        Top Rated
      </h2>
      <div className="flex overflow-x-scroll pb-4 hide-scroll-bar mt-2 mx-2 ">
        <div className="grid grid-flow-col grid-rows-2 gap-4">
          {filteredGames
            .filter((game) => game.rate > 4.5)
            .map((item) => (
              <HorizontalListItem
                key={item.id}
                game={item}
                handleItemClick={handleItemClick}
              />
            ))
            .reverse()}
        </div>
      </div>

      <div className=" h-px bg-gray-700 mx-4" />

      <div className="flex flex-row justify-between items-baseline mx-4 mt-4">
        <h2 className="text-white medium text-3xl">All</h2>
      </div>

      {filteredGames.map((item) => (
        <VerticalListItem
          key={item.id}
          game={item}
          handleItemClick={handleItemClick}
        />
      ))}

      <div className="h-20"></div>
    </div>
  );
};

export default GamesPage;
